var render = function () {
  var _vm$resultCreatedBook, _vm$resultCreatedBook2, _vm$resultCreatedBook3;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.resultCreatedBooking ? _c('div', [_c('p', {
    staticClass: "py-1 font-medium-2 fw-700 text-success"
  }, [_vm._v(" Đặt vé thành công ! ")]), _c('b-tabs', {
    attrs: {
      "nav-class": "bg-gray",
      "pills": ""
    }
  }, [_c('b-tab', {
    staticClass: "pb-2",
    attrs: {
      "title": 'Mã đặt chỗ',
      "title-item-class": "fw-700",
      "title-link-class": "px-75 hover-bg-light-warning",
      "active": ""
    }
  }, [_c('div', {
    staticClass: "fw-700 d-flex align-items-center gap-1 mb-1"
  }, [_c('span', {
    staticClass: "mr-25"
  }, [_vm._v(_vm._s(_vm.$t('flight.bookingCode')) + ":")]), _c('BButton', {
    staticClass: "p-50 text-airline fw-700 font-medium-4",
    attrs: {
      "variant": "outline-info"
    },
    on: {
      "click": function click($event) {
        return _vm.handleGoToReservation(_vm.resultCreatedBooking.bookingId);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.resultCreatedBooking.pnr) + " "), _c('feather-icon', {
    staticClass: "ml-25 mb-25",
    attrs: {
      "icon": "ExternalLinkIcon",
      "size": "14"
    }
  })], 1), _c('BButton', {
    staticClass: "px-50 py-75 rounded-lg fw-700 ml-1",
    attrs: {
      "variant": "outline-info"
    },
    on: {
      "click": function click($event) {
        return _vm.goToTicketFace(_vm.resultCreatedBooking.bookingId);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('reservation.exportTicket')) + " "), _c('feather-icon', {
    staticClass: "ml-25",
    attrs: {
      "icon": "ExternalLinkIcon",
      "size": "14"
    }
  })], 1)], 1), _c('div', {
    staticClass: "fw-700"
  }, [_c('span', {
    staticClass: "mr-25"
  }, [_vm._v(" Tổng tiền vé: ")]), _c('span', {
    staticClass: "text-danger font-medium-2"
  }, [_vm._v(" " + _vm._s(_vm.formatCurrency((_vm$resultCreatedBook = _vm.resultCreatedBooking) === null || _vm$resultCreatedBook === void 0 ? void 0 : (_vm$resultCreatedBook2 = _vm$resultCreatedBook.pricingInfo) === null || _vm$resultCreatedBook2 === void 0 ? void 0 : _vm$resultCreatedBook2.total)) + " ")]), _c('span', {
    staticClass: "ml-1 text-warning font-italic fw-600"
  }, [_vm._v(" (Chưa bao gồm phí dịch vụ) ")])])]), _c('b-tab', {
    attrs: {
      "title": "1A Booking",
      "title-item-class": "fw-700 border-left-secondary border-right-secondary",
      "title-link-class": "px-75"
    }
  }, [_c('ShortenBooking', {
    attrs: {
      "shorten-text": ((_vm$resultCreatedBook3 = _vm.resultCreatedBooking) === null || _vm$resultCreatedBook3 === void 0 ? void 0 : _vm$resultCreatedBook3.bookingImage) || undefined
    }
  })], 1)], 1)], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }